export const compile = cb => {
  if (window.MathJax) {
    window.MathJax.Hub.Typeset(null, cb);
  }
};
